import type { Dispatch, FC, SetStateAction } from 'react';

import { Outlet } from 'react-router';

import { DashboardEditLockProvider } from '@/features/dashboard/state/DashboardEditLockProvider';
import { ExportProvider } from '@/features/data-hub';
import { KeyDialogContext } from '@/features/data-hub/state/KeyDialogContext';
import { KeyDialog } from '@/features/profile';
import { SymbolSelector } from '@/features/symbol-selector';
import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';

const renderKeyDialog = (open: boolean, setOpen: (value: boolean) => void) => (
  <KeyDialog
    open={open}
    setOpen={setOpen as Dispatch<SetStateAction<boolean>>}
  />
);

export const PublicLayout: FC = () => {
  const gxToken = useStorageValue(StorageKeys.GxToken);

  if (gxToken) {
    return (
      <DashboardEditLockProvider>
        <KeyDialogContext value={renderKeyDialog}>
          <ExportProvider>
            <SymbolSelector />
            <Outlet />
          </ExportProvider>
        </KeyDialogContext>
      </DashboardEditLockProvider>
    );
  }

  return <Outlet />;
};
